
import * as XLSX from "xlsx";

export default async (
    data,
    sheetName,
    fileName
) => {
    try {
        const jsonWorkSheet = XLSX.utils.json_to_sheet(data);
        const workBook = {
            SheetNames: [sheetName], // 指定有序 sheet 的 name
            Sheets: {
                [sheetName]: jsonWorkSheet, // 表格数据内容
            },
        };
        console.log(jsonWorkSheet);
        console.log(workBook);
        console.log(XLSX);

        return XLSX.writeFile(workBook, fileName); // 向文件系统写出文件
    } catch (error) {
        console.log(error);
    }
};